export default __webpack_public_path__ + "static/media/Hub-to-hub Automated Transport.2bbbc0b0.pdf";